import windowService from "./window-service";
import { EventActions, VERSION } from "../utility/constants";
import { GlobalDataLayerService } from "./analytics/global-data-layer-service";
import logger from "./logger";

// Avoid turning this function into a promise
export function onComponentDidLoad(): void {
  windowService.version = VERSION;
  GlobalDataLayerService.getInstance().pushDataLayerEvent(
    EventActions.GENERAL_LOAD,
  );
  logger.info("NAVIGATION_LOAD");
}
